import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  gap: "$md",
  flexWrap: "wrap",
  flexDirection: "column",
  "&[data-orientation='horizontal']": {
    flexDirection: "row"
  }
});